import * as React from 'react'
import NextImage from 'next/image'

interface ComponentProps {
  src?: string
  alt?: string
}

const PLACEHOLDER_SRC = '/placeholder.png'

export const ImageWithPlaceholder = ({
  src,
  alt,
  ...props
}: ComponentProps & Partial<React.ComponentProps<typeof NextImage>>) => {
  const [hasError, setHasError] = React.useState(false)

  const imageSrc = hasError || !src ? PLACEHOLDER_SRC : src

  return (
    <NextImage
      unoptimized
      {...props}
      alt={alt || ''}
      src={imageSrc}
      onError={({ currentTarget }) => {
        currentTarget.onerror = null
        setHasError(true)
      }}
    />
  )
}
